import I18n from 'I18n';
// @ts-expect-error FIXME
import whiteiOSAppStore from 'bender-url!../../../images/ios-app-store-button-white.svg';
// @ts-expect-error FIXME
import blackiOSAppStore from 'bender-url!../../../images/ios-app-store-button-black.svg';
import CUIImage from '../CUIImage/CUIImage';
import CUILink from '../CUILink/CUILink';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CUIAppStoreButton({
  color = 'black',
  campaign
}) {
  return /*#__PURE__*/_jsx(CUILink, {
    href: `https://apps.apple.com/app/apple-store/id6479700065?pt=391837&ct=${campaign}&mt=8`,
    "aria-label": I18n.text('connect.appStoreButton.iosAriaLabel'),
    children: /*#__PURE__*/_jsx(CUIImage, {
      alt: "",
      height: "40px",
      src: color === 'black' ? blackiOSAppStore : whiteiOSAppStore
    })
  });
}